import { Loading } from 'element-ui';

let loadingCount = 0;
let loading;

const startLoading = function() {
	loading = Loading.service({
    	lock: true,
    	text: '加载中……',
    	background: 'rgba(0, 0, 0, 0.7)'
  	});
}

const endLoading = function () {
	loading.close();
}

export const showLoading = function() {
	if (loadingCount === 0) {
    	startLoading();
  	}
  	loadingCount += 1;
}

export const hideLoading = function() {
  	if (loadingCount <= 0) {
   	 	return;
  	}
  	loadingCount -= 1;
  	if (loadingCount === 0) {
    	endLoading();
  	}
};


//////////////////
// WEBPACK FOOTER
// ./static/js/loading.js
// module id = D9W+
// module chunks = 12